var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShadedI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 499,
    viewBox: "0 0 107 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 0H107V499H0V0Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadedI);
export default __webpack_public_path__ + "static/media/shadedI.5f5b3db90cdb4e730779fb6461c2c6aa.svg";
export { ForwardRef as ReactComponent };